/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Initiate_Stripe_ConnInputs */

const en_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to initiate Stripe Connect linkage.`)
};

const es_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar el enlace de Stripe Connect.`)
};

const fr_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'initialisation de la liaison Stripe Connect.`)
};

const de_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Initiieren der Stripe Connect-Verknüpfung.`)
};

const ja_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connectのリンク開始に失敗しました。`)
};

const zh_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法启动 Stripe Connect 关联。`)
};

const ar_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في بدء عملية الربط مع Stripe Connect.`)
};

const id_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal memulai penautan Stripe Connect.`)
};

const it_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile avviare il collegamento con Stripe Connect.`)
};

const ru_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось начать подключение Stripe.`)
};

const pt_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao iniciar a conexão com o Stripe Connect.`)
};

const ko_failed_to_initiate_stripe_conn = /** @type {(inputs: Failed_To_Initiate_Stripe_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect 연동을 시작하지 못했습니다.`)
};

/**
* | output |
* | --- |
* | "Failed to initiate Stripe Connect linkage." |
*
* @param {Failed_To_Initiate_Stripe_ConnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const failed_to_initiate_stripe_conn = /** @type {((inputs?: Failed_To_Initiate_Stripe_ConnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Initiate_Stripe_ConnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failed_to_initiate_stripe_conn(inputs)
	if (locale === "es") return es_failed_to_initiate_stripe_conn(inputs)
	if (locale === "fr") return fr_failed_to_initiate_stripe_conn(inputs)
	if (locale === "de") return de_failed_to_initiate_stripe_conn(inputs)
	if (locale === "ja") return ja_failed_to_initiate_stripe_conn(inputs)
	if (locale === "zh") return zh_failed_to_initiate_stripe_conn(inputs)
	if (locale === "ar") return ar_failed_to_initiate_stripe_conn(inputs)
	if (locale === "id") return id_failed_to_initiate_stripe_conn(inputs)
	if (locale === "it") return it_failed_to_initiate_stripe_conn(inputs)
	if (locale === "ru") return ru_failed_to_initiate_stripe_conn(inputs)
	if (locale === "pt") return pt_failed_to_initiate_stripe_conn(inputs)
	return ko_failed_to_initiate_stripe_conn(inputs)
});